export default "__VITE_ASSET__nX2P214e__"